// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription .swiper {
  width: calc(100vw - 4px);
  height: 100%;
  padding-top: 3px;
}
.subscription .swiper-slide {
  height: auto;
  width: 80%;
}
.subscription .swiper-slide > div {
  height: calc(100% - 32px);
  margin-left: auto;
  margin-right: auto;
  width: 75vw;
  margin-bottom: 24px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
